import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0Z",
			fill: "#F10404"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 11.2001C9.45 11.2001 9 10.6601 9 10.0001V5.20001C9 4.54001 9.45 4 10 4C10.55 4 11 4.54001 11 5.20001V10.0001C11 10.6601 10.55 11.2001 10 11.2001Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15.9999H9V13.5999H11V15.9999Z",
			fill: "white"
		})
	]
});
export default SvgRedError;
